import { render, staticRenderFns } from "./SingleClusterInfo.vue?vue&type=template&id=37be0f3b&scoped=true&"
import script from "./SingleClusterInfo.vue?vue&type=script&lang=js&"
export * from "./SingleClusterInfo.vue?vue&type=script&lang=js&"
import style0 from "./SingleClusterInfo.vue?vue&type=style&index=0&id=37be0f3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37be0f3b",
  null
  
)

export default component.exports